import _ from 'lodash'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import $glRouter from '@/services/$glRouter'

// map envs to apis
const ENV_API_MAP = {
  production: '/api',
  development: 'http://localhost:3000/api'
}

// init $glHttp (an axiosInstance)
let $glHttp = axios.create({
  withCredentials: true,
  baseURL: ENV_API_MAP[process.env.NODE_ENV],
  headers: {
    'Content-Type': 'application/json'
  }
})

// fn: valid response interceptor
let _validResponseInterceptor = (r) => {
  return r.data
}

// fn: invalid resonse interceptor
let _invalidResponseInterceptor = (e) => {
  let currentRoute = $glRouter.getCurrentRoute()

  // if response status is 401 and route requires authentication
  if (_.get(e, 'response.status') === 401 && _.includes(_.get(currentRoute, 'meta.requires'), 'auth')) {
    // store: commit logout
    store.commit('logout')

    // redirect to login page
    router.push('login')
  }

  // declare response
  let response

  if (_.isObject(e)) {
    // if response is undefined but message isn't -> use message
    // else if data accessible -> use data
    // else -> use response
    if (_.isUndefined(e.response) && !_.isUndefined(e.message)) response = e.message
    else if (_.isObject(e.response) && !_.isUndefined(e.response.data)) response = e.response.data
    else response = e.response
  } else response = e

  // return rejected promise
  return Promise.reject(response)
}

// bind interceptors
$glHttp.interceptors.response.use(_validResponseInterceptor, _invalidResponseInterceptor)

// export $glHttp
export default $glHttp



// WEBPACK FOOTER //
// ./src/services/$glHttp.js